import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { BadgeCheck } from 'lucide-react';
import {
  WHITE_LABEL_ACCENT_COLOR,
  WHITE_LABEL_BRAND,
} from '../../../../lib/white-label';
import { Tooltip } from 'react-tooltip';
import { Dayjs } from 'dayjs';
import Progress from '../progress/progress';

const PurchaseHead = styled.div`
  display: grid;
  grid-template-columns: 114px 1fr;
  grid-gap: 0 19px;
  width: 100%;
`;

const PurchaseHeadImage = styled.div`
  position: relative;
  height: 104px;
  width: 104px;
  span {
    border-radius: 10px;
  }
`;

const OrderTag = styled.div`
  background: #e3e7f2;
  height: 26px;
  padding: 3px 11px;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
    color: #9da3b7;

    span {
      font-weight: 600;
      font-size: 14px;
      line-height: 140%;
      color: #000000;
    }
  }
`;

const PurchaseHeadBody = styled.div`
  & > .row {
    display: flex;
    grid-gap: 7px;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }
  .product-name {
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    color: #05030d;
    margin-bottom: 6px;
  }
  .supported-retailers {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #9da3b7;
    margin-bottom: 4px;
  }
`;

interface CardHeaderProps {
  type: number;
  tags: [];
  id: string;
  botName: string;
  botImage: string;
  listingMode: string;
  startDate: Dayjs;
  endDate: Dayjs;
  createdAt: Dayjs;
  rentalDays: number;
  dataTour?: string;
}

const CardHeader = (props: CardHeaderProps): JSX.Element => {
  return (
    <PurchaseHead data-tour={props.dataTour}>
      <PurchaseHeadImage>
        <Image
          alt=""
          layout="fill"
          src={props.botImage}
          className="rounded-md"
        />
      </PurchaseHeadImage>
      <PurchaseHeadBody>
        <div className="flex flex-row">
          <p className="product-name">{props.botName}</p>
          {props.listingMode === 'DIRECT' && (
            <>
              <BadgeCheck
                color={'#FFFFFF'}
                fill={WHITE_LABEL_ACCENT_COLOR}
                className="ml-2"
                data-tooltip-content={`Partnered with ${WHITE_LABEL_BRAND}`}
                data-tooltip-id={`${props.botName}-partner-tooltip`}
              />
              <Tooltip id={`${props.botName}-partner-tooltip`} place="right" />
            </>
          )}
        </div>
        <div className="flex flex-row gap-x-2 flex-wrap">
          <OrderTag className="min-w-content mb-1 rounded-md truncate text-ellipsis">
            <p data-tour="step-2">
              ID: <span>{props.id}</span>
            </p>
          </OrderTag>
          <OrderTag className="min-w-content mb-1 rounded-md truncate text-ellipsis">
            <p data-tour="step-2">Purchased: {props.createdAt.format('L')}</p>
          </OrderTag>
        </div>
        <div className="mt-2">
          <Progress
            startDate={props.startDate}
            endDate={props.endDate}
            rentalDays={props.rentalDays}
            createdAt={props.createdAt}
            type={props.type}
          />
        </div>
      </PurchaseHeadBody>
    </PurchaseHead>
  );
};

export default CardHeader;
